import { GET_AWBS_PENDING, GET_AWBS_SUCCEEDED, GET_AWBS_FAILED, DELETE_AWBS } from '../actions/actionTypes';
import Awb from '../../models/Awb';

export default interface AwbsState {
  loading: boolean,
  awbs: Awb[],
  error: string | null,
} 

const initialState:AwbsState = {
  loading: false,
  awbs:[],
  error: null,
}

export const awbsReducer = (state:AwbsState = initialState, action: any) => {

  switch (action.type) {
    case GET_AWBS_PENDING:
      return {...state, loading:true};
    case GET_AWBS_SUCCEEDED:
      return {
        ...state, 
        loading:false,
        error:null,
        awbs: [...action.payload]
      };
    case GET_AWBS_FAILED:
      return {
        ...state,
        loading:false,
        error: action.payload.error
      };
    case DELETE_AWBS:
      return {
        ...state,
        awbs: [...state.awbs, action.payload],
      };   
    default:
     return state
  }
};
